import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "community_container" }
const _hoisted_2 = { class: "list_wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "default"
}
const _hoisted_4 = { class: "default_box" }
const _hoisted_5 = { class: "img_tag" }
const _hoisted_6 = { class: "default_text_box" }
const _hoisted_7 = { class: "default_text" }
const _hoisted_8 = { class: "default_ellipsis" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "head_img_wrap" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "title_author" }
const _hoisted_14 = { class: "title_label" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "item_content" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "img_item"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "Lottie_color" }
const _hoisted_22 = { class: "announcing_text" }
const _hoisted_23 = { class: "announcing_text" }
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = {
  key: 1,
  class: "default-img"
}
const _hoisted_26 = {
  key: 0,
  class: "img-num"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "item_content" }
const _hoisted_29 = {
  key: 0,
  class: "item_img_article"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "count_time" }
const _hoisted_33 = {
  key: 0,
  class: "count_warpper"
}
const _hoisted_34 = { class: "count_item" }
const _hoisted_35 = { class: "count_item_text" }
const _hoisted_36 = { class: "count_item" }
const _hoisted_37 = { class: "count_item_text" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "iconfont icon-icon_shouye_dianzan" }
const _hoisted_40 = { class: "iconfont icon-icon_shouye_hangyedongtai_dianzan_O active" }
const _hoisted_41 = { class: "count_item_text" }
const _hoisted_42 = {
  key: 1,
  class: "cancel_pop"
}

import { Record } from '@/api/Models/CommunityBoardContentList'
import { Attachment } from '@/api/Models/Attachment'
import { isVideo, isFile } from '@/utils/file'
import Player from './Player.vue'
import { computed, getCurrentInstance, ComponentInternalInstance, ref } from 'vue'
import Popover from '@/components/Popover.vue'
import { calcImageScaleWithSize, screenWidth, toW } from '@/utils'
import { useRouter } from 'vue-router'
import APIRequest from '@/api'
import { formatLang, formatTime } from '@/utils/format'
import { useI18n } from 'vue-i18n'
import { useComponentStore } from '@/stores/components'
import { storeToRefs } from 'pinia'
import { showToast } from 'vant'
import LottieFlow from '../../shortVideo/components/LottieFlow.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    articleData: {},
    active: {},
    pageType: {},
    page: {}
  },
  emits: ['showPreview', 'cancelCollect'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const flag = ref<boolean>(props.pageType !== 1)
const { t } = useI18n()
const getSize = (size: string) => {
  const divWidth = screenWidth - 32 - 24
  const divHeight = divWidth * 0.75
  let width = divWidth + 'px'
  let height = divHeight + 'px'
  if (size) {
    const originSize = JSON.parse(size)
    width = originSize.imageWith
    height = originSize.imageHigh
    if (Number(originSize.imageWith) > Number(originSize.imageHigh)) {
      width = divWidth + 'px'
      height = originSize.imageHigh * (divWidth / originSize.imageWith) + 'px'
    } else {
      height = divHeight + 'px'
      width = originSize.imageWith * (divHeight / originSize.imageHigh) + 'px'
    }
  }
  return {
    width,
    height
  }
}
const recordData = computed(() => {
  try {
    const filteredData = props.articleData?.map((item) => {
      return {
        ...item,
        ...item?.communityContent,
        attachments: item?.communityContent
          ? item?.communityContent.attachments
              ?.filter((el) => !isFile(el.type))
              ?.map((e) => {
                let imgSize = {
                  imageWith: '340',
                  imageHigh: '250'
                }
                if (e.expandInfo) {
                  imgSize = JSON.parse(e.expandInfo)
                }
                return {
                  previewUrl: isVideo(e.type)
                    ? e.previewUrl
                    : calcImageScaleWithSize(
                        e.previewUrl as string,
                        parseInt(imgSize.imageWith),
                        parseInt(imgSize.imageHigh),
                        1500,
                        1500
                      ),
                  type: e.type,
                  name: e.name,
                  id: e.id,
                  coverUrl: e.coverUrl,
                  size: e?.expandInfo,
                  status: e?.status
                }
              }) || []
          : item?.attachments
              ?.filter((el) => !isFile(el.type))
              ?.map((e) => {
                let imgSize = {
                  imageWith: '340',
                  imageHigh: '250'
                }
                if (e.expandInfo) {
                  imgSize = JSON.parse(e.expandInfo)
                }
                return {
                  previewUrl: isVideo(e.type)
                    ? e.previewUrl
                    : calcImageScaleWithSize(
                        e.previewUrl as string,
                        parseInt(imgSize.imageWith),
                        parseInt(imgSize.imageHigh),
                        1500,
                        1500
                      ),
                  type: e.type,
                  name: e.name,
                  id: e.id,
                  coverUrl: e.coverUrl,
                  size: e.expandInfo,
                  status: e.status
                }
              }) || []
      }
    })
    return filteredData as unknown as Record[]
  } catch (error) {
    return []
  }
})

const { proxy } = getCurrentInstance() as ComponentInternalInstance

const likeHandle = async (item: Record) => {
  const { code } = await APIRequest.CommentLike.postLikeSend({
    likeModule: 3,
    likeModuleId: item.id,
    loadingShow: '0'
  })
  if (code === 1) {
    item.likeCount = Number(item.likeCount) + 1
    item.isLike = true
    proxy?.$forceUpdate()
  }
}
const dontLikeHandle = async (item: Record) => {
  const { code } = await APIRequest.CommentLike.postLikeCancel({
    likeModule: 3,
    likeModuleId: item.id
  })
  if (code === 1) {
    item.likeCount = Number(item.likeCount) - 1
    item.isLike = false
    proxy?.$forceUpdate()
  }
}
const toggleIsLike = (item: Record) => {
  if (item.isLike) {
    dontLikeHandle(item)
  } else {
    likeHandle(item)
  }
}

const emits = __emit
const showPreview = (attachments: Attachment[], index: number) => {
  emits('showPreview', { attachments, index })
}

const router = useRouter()
const handleJump = (id: string, type?: string, boardId?: string, status?: number) => {
  const componentsStore = useComponentStore()
  const { includeComponents } = storeToRefs(componentsStore)
  if (!includeComponents.value.includes('communityDetail') && !props.page) {
    componentsStore.setIncludeComponents([...includeComponents.value, 'communityDetail'])
  }
  if (props.page) {
    const filteredArr = includeComponents.value.filter((element) => element !== 'communityDetail')
    componentsStore.setIncludeComponents(filteredArr)
  }
  if (type && isVideo(type)) {
    if (status === 3) {
      router.push({
        path: '/rollVideo',
        query: {
          sortType: 0,
          id,
          boardId
        }
      })
    } else {
      showToast(t('video_processing_h5'))
    }
  } else {
    router.push({ path: '/comDetailLevel', query: { id, from: props.page } })
  }
}

const handleDefaultVideo = () => {
  showToast(t('video_processing_h5'))
}

const cancelCollect = (item: { collectModuleId: string; collectModuleType: number }) => {
  emits('cancelCollect', { collectModuleId: item.collectModuleId, collectModuleType: item.collectModuleType })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list_item",
          key: index
        }, [
          (item?.isExits === 0 && __props.pageType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('pc_course_invalid')), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('pc_community_is_deleted')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(Popover, {
                      onCancel: ($event: any) => (cancelCollect(item))
                    }, null, 8, ["onCancel"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", {
                  class: "item_title",
                  onClick: ($event: any) => (handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: item.avatarFileUrl ? item.avatarFileUrl : require('@/assets/images/wx_share_default.jpg'),
                      class: "title_img",
                      alt: ""
                    }, null, 8, _hoisted_11),
                    (item.wearImageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "wear_img",
                          src: item.wearImageUrl,
                          alt: ""
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item?.createByName), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item?.postName), 1)
                ], 8, _hoisted_9),
                _createElementVNode("div", {
                  class: _normalizeClass(["item_subtitle", item.type === 2 ? 'subTitle' : '']),
                  onClick: ($event: any) => (handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status))
                }, _toDisplayString(item?.title), 11, _hoisted_15),
                (item.type !== 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(item?.articleText), 1),
                      (item?.attachments)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["img-wrapper", 
                item.attachments?.length === 1
                  ? 'item_img_one'
                  : item.attachments?.length === 2
                  ? 'item_img_two'
                  : 'item_img'
              ]),
                            onClick: _withModifiers(($event: any) => (
                item?.attachments.length === 1 && _unref(isVideo)(item?.attachments[0]?.type)
                  ? null
                  : handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status)
              ), ["stop"])
                          }, [
                            (item?.attachments.length === 1 && _unref(isVideo)(item?.attachments[0]?.type))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (+item?.attachments[0]?.status === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createVNode(Player, {
                                          id: item?.attachments[0].id,
                                          url: item?.attachments[0].previewUrl,
                                          coverUrl: item?.attachments[0].coverUrl,
                                          boardId: item.boardId,
                                          rollVideoId: item.id
                                        }, null, 8, ["id", "url", "coverUrl", "boardId", "rollVideoId"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "default-video",
                                        onClick: handleDefaultVideo
                                      }, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(LottieFlow)
                                        ]),
                                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('under_release_h5')), 1),
                                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('video_refresh_h5')), 1)
                                      ]))
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.attachments.slice(0, 3), (i, k) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "img-box",
                                      key: k
                                    }, [
                                      (i?.previewUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: i?.previewUrl,
                                            class: _normalizeClass(item?.attachments.length === 1 ? 'cale-item' : 'img_item'),
                                            style: _normalizeStyle(item?.attachments.length === 1 ? getSize(i.size) : {}),
                                            onClick: _withModifiers(($event: any) => (showPreview(item.attachments, k)), ["stop"]),
                                            alt: ""
                                          }, null, 14, _hoisted_24))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_25))
                                    ]))
                                  }), 128)),
                                  (item.attachments?.length > 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(formatLang)(_ctx.$t('pc_community_total_piece'), [item?.attachments.length + ''])), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ], 10, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "item-article",
                      onClick: ($event: any) => (handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status))
                    }, [
                      _createElementVNode("p", _hoisted_28, _toDisplayString(item?.articleText), 1),
                      (item?.attachments && item?.attachments.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attachments, (i, k) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: k,
                                src: i?.previewUrl,
                                class: "img_item",
                                alt: ""
                              }, null, 8, _hoisted_30))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_27)),
                _createElementVNode("div", {
                  class: "item_count",
                  onClick: ($event: any) => (handleJump(item.id, item?.attachments[0]?.type, item?.boardId, +item?.attachments[0]?.status))
                }, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(formatTime)(item?.createTime)), 1),
                  (flag.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-icon_shequzhongxin_liulanliang" }, null, -1)),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(toW)(item?.viewCount)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_pinglun" }, null, -1)),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(toW)(item.commentCount)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "count_item",
                          onClick: _withModifiers(($event: any) => (toggleIsLike(item)), ["stop"])
                        }, [
                          _withDirectives(_createElementVNode("i", _hoisted_39, null, 512), [
                            [_vShow, !item.isLike]
                          ]),
                          _withDirectives(_createElementVNode("i", _hoisted_40, null, 512), [
                            [_vShow, item.isLike]
                          ]),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(toW)(Number(item?.likeCount))), 1)
                        ], 8, _hoisted_38)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createVNode(Popover, {
                          onCancel: ($event: any) => (cancelCollect(item))
                        }, null, 8, ["onCancel"])
                      ]))
                ], 8, _hoisted_31)
              ], 64))
        ]))
      }), 128))
    ])
  ]))
}
}

})